import React, { useState, useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { findAllDeparturesEvent } from '../../../_events/departures/find_departures.event';
import { message } from "antd";
import { findAllMaxMinPricesEvent } from "../../../_events/max_min_prices/find_max_min_prices.event";

const Table = (props) => {

    const columns = [
        { field: 'ref', headerName: 'Referencia', width: 200 },
        { field: 'min_price', headerName: 'Precio máximo', width: 200 },
        { field: 'max_price', headerName: 'Precio mínimo', width: 200 },
        { field: 'client_price', headerName: 'Precio cliente', width: 200 },
    ]; 

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={props.data}
                columns={columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

export default Table;